import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clientsearch',
  templateUrl: './clientsearch.component.html',
  styleUrls: ['./clientsearch.component.scss']
})
export class ClientsearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
